// extracted by mini-css-extract-plugin
export var articleQuote = "News-module--articleQuote--c2c0f";
export var container = "News-module--container--c1def";
export var decor = "News-module--decor--bb848";
export var hamburger = "News-module--hamburger--4ae92";
export var link = "News-module--link--30857";
export var logo = "News-module--logo--b5731";
export var logoList = "News-module--logoList--1a1f6";
export var newsSources = "News-module--newsSources--f79ec";
export var reactCalendarMonthViewDays = "News-module--react-calendar__month-view__days--7adcc";
export var reactCalendarTile = "News-module--react-calendar__tile--55c49";
export var reactCalendarTileActive = "News-module--react-calendar__tile--active--c548c";
export var relativeWrapper = "News-module--relativeWrapper--0866a";
export var tag = "News-module--tag--455ca";
export var units = "News-module--units--66a63";